// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__iRSHR","header":"ReportDetails_header__NdDPe","title":"ReportDetails_title__2-KYg","left":"ReportDetails_left__Ma06A"};